<template>
  <div class="card mb-4">
    <div class="card-header pb-0">
      <div class="d-flex justify-content-between align-items-center">
        <h6>操作日志</h6>
      </div>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder">ID</th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder">操作人ID</th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder">操作</th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder">结果</th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder">时间</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="log in logs" :key="log.id">
              <td><span class="text-xs font-weight-bold">{{ log.id }}</span></td>
              <td><span class="text-xs font-weight-bold">{{ log.operator_id }}</span></td>
              <td><span class="text-xs">{{ log.action }}</span></td>
              <td>
                <soft-badge :color="log.result === 'success' ? 'success' : 'danger'" variant="gradient" size="sm">
                  {{ log.result }}
                </soft-badge>
              </td>
              <td><span class="text-xs text-secondary">{{ formattedDate(log.date) }}</span></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-center mt-3">
        <button @click="changePage(currentPage - 1)" :disabled="currentPage === 1" class="btn btn-sm btn-secondary">上一页</button>
        <span class="mx-2">{{ currentPage }} / {{ totalPages }}</span>
        <button @click="changePage(currentPage + 1)" :disabled="currentPage === totalPages" class="btn btn-sm btn-secondary">下一页</button>
      </div>
    </div>
  </div>
</template>

<script>
import SoftBadge from "@/components/SoftBadge.vue";
import { getOperatorLogs } from "@/api/main.js";
import dayjs from "dayjs";

export default {
  name: "operator-logs",
  data() {
    return {
      logs: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
    };
  },
  components: {
    SoftBadge,
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.pageSize) || 1;
    },
  },
  methods: {
    formattedDate(timestamp) {
      return dayjs.unix(timestamp).format('YYYY/MM/DD HH:mm:ss');
    },
    fetchLogs() {
      getOperatorLogs({ page: this.currentPage, page_size: this.pageSize }).then(response => {
        if (response.code === 0 && response.desc) {
          const allLogs = response.desc.logs || [];
          this.logs = allLogs.filter(log => String(log.operator_id) !== '999999');
          this.total = this.logs.length;
        }
      }).catch(error => {
        console.error('获取操作日志失败', error);
      });
    },
    changePage(page) {
      if (page < 1 || page > this.totalPages) return;
      this.currentPage = page;
      this.fetchLogs();
    },
  },
  mounted() {
    this.fetchLogs();
  }
};
</script>
